<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="100">


    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            Add a template
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div style="margin: 15px;">

            <div>
              <div>Template Name</div>
              <div>
                <mat-form-field>
                <input matInput placeholder="Template name" type="text" [(ngModel)]="templateName" (keyup)="changeTemplateName()" />
                </mat-form-field>
              <button style="margin-left: 10px;" mat-raised-button color="primary" [disabled]="!canAdd || checkExistsTimeout != null" [class.spinner]="checkExistsTimeout != null" (click)="addTemmplate()">Proceed</button>
              </div>
            </div>

            <div style="margin-top: 10px;">
              Please enter a name for the template. The template will be <b>publicly reachable</b> with this URL:<br />
              <a href="{{ externalUrlPreview }}">{{ externalUrlPreview }}</a>

            </div>

            <div style="margin-top: 10px;">

            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

